import React, { useState, useEffect } from "react";
import { PHP_API, PHP_BACK } from "../../utils/Common";
import Axios from "axios";
import { validarSemana } from "../../utils/datetools";
import Formulas from "./Formulas";
import FormularioRegistroBloqueEdicion from "../pages/planes/PlanSimebraComponents/formularioRegistroBloque/FromaularioRegistroBloqueEdicion";

const AgregarEntradaPlan = (props) => {
    const canedit = props.canEdit;
    const formulas = new Formulas()
    const [element, setelement] = useState({ ...(props.elemento ?? {}) });
    const [colores, setcolores] = useState([]);
    const [flores, setflores] = useState([]);
    const [tipos, settipos] = useState([]);
    const [tiposOrdenados, settiposOrdenados] = useState({});
    var count = 0;

    const keyGen = () => {
        count++;
        return count;
    }

    const cambiarDato = (campo, dato) => {
        formulas.inicalizar_valores(element);
        if (campo == 'densidad') formulas.densidad(dato);
        else if (campo == 'cantidadTallos') formulas.tallos(dato);
        else if (campo == 'semillas') formulas.semillas(dato);
        else if (campo == 'reqm2') formulas.metros(dato);
        else if (campo == 'plantas') formulas.plantas(dato);
        else if (campo == 'recuperacion') formulas.recuperacion(dato);
        else if (campo == 'por_germinacion') formulas.germinacion(dato);
        else if (campo == 'charolas') formulas.charolas(dato);
        else if (campo == 'densidad') formulas.densidad(dato);
        else if (campo == 'propagacion') formulas.modificarPropagacionCampo(dato, formulas.values.campo);
        else if (campo == 'campo') formulas.modificarPropagacionCampo(formulas.values.propagacion, dato);
        else if (campo == 'semanainicio' && dato.length === 4) formulas.modificarSemanaSiembra(dato);
        else if (campo == 'transplante' && dato.length === 4) formulas.modificarSemanaTransplante(dato);
        else if (campo == 'semanaCosecha' && dato.length === 4) formulas.modificarSemanacosecha(dato);

        formulas.values.charolas = (formulas.values.por_germinacion > 0 && formulas.values.plantas > 0) ?
            parseFloat((formulas.values.plantas / 288 / formulas.values.por_germinacion).toFixed(2)) : 0;
        setelement(formulas.getValues());

    }


    //Cierra la ventana de dialogo si se da click en anguna parte fuera del cuadro de dialogo
    const cerrarDesdePadre = (e) => {
        const padre = document.getElementById('padre');
        const hijo = document.getElementById('hijo');
        if (padre && hijo && !hijo.contains(e.target)) { props.cerrar(); }
    }

    //Ajusta los valores que cambian al ajustar el color
    const cambiarColor = (id) => {
        let old = { ...element };
        old.colorId = id;
        for (let i = 0; i < colores.length; i++) {
            if (colores[i].id == id) {
                old.color = colores[i].color;
                i = 26818181831381;
            }
        }
        setelement({ ...old });
    }

    //Cambia de tipo de flor, a la vez que actualiza los tipos de flor compatibles
    const cambioFlor = (id) => {
        let old = { ...element };
        old.florId = id;
        for (let i = 0; i < flores.length; i++) {
            if (flores[i].id == id) {
                old.flor = flores[i];
                break;
            }
        }
        let tipos = { ...tiposOrdenados };
        settipos([...tipos[old.florId]]);
        old.variedadesId = tipos[old.florId][0].id;
        setelement({ ...old });
    }

    //Actualiza los tipos de flor acorde a la flor seleccionada
    const actualizarTipos = (florID, tipos) => {
        let old = element;
        if (!tipos) tipos = { ...tiposOrdenados };

        if (!florID && element && element.flor && element.flor.id) florID = element.flor.id;

        if (!florID) {
            old.variedadesId = generarRawTipos(tipos);
            setelement({ ...old });
            return;
        }

        settipos([...tipos[florID]]);
        if (tipos[florID]) old.variedadesId = tipos[florID][0].id;
        else old.variedadesId = null;
        setelement(old);

    }

    const generarRawTipos = (tipos) => {
        if (!tipos) tipos = { ...tiposOrdenados };
        let rawTipo = [];
        for (const key in tipos) {
            let bloque = [...tipos[key]];
            bloque.forEach(b => {
                rawTipo.push(b);
            });
        }
        settipos([...rawTipo]);
        if (rawTipo.length > 0) return rawTipo[0].id;
        return null;
    }

    const cambiarVariedad = (id) => {
        if (!element) return;
        let old = { ...element };
        old.variedadesId = id;
        setelement({ ...old });

    }

    const accion = (tipo) => {
        let n;
        if (tipo == 3) {
            n = { tipo: 3, pid: element.pid }
        }
        else {
            n = datosActNvo();
            n['tipo'] = tipo;
        }
        props.actualizar(n);

    }

    const datosActNvo = () => {
        let e = {};
        let keys = Object.keys(element)
        for (let i = 0; i < keys.length; i++) {
            let k = keys[i];
            e[k] = element[k];
        }

        return e;
    }

    useEffect(() => {
        Axios.get(PHP_BACK + 'api/datos_estandar_formularios').then((r) => {
            setcolores([...r.data.colores]);
            setflores([...r.data.flores]);
            settiposOrdenados({ ...r.data.tipos });
        });
    }, []);


    return (
        <div className='vh-100 vw-100 text-center bg-white5 blur-xl p-1 m-0' onClick={cerrarDesdePadre} id="padre" style={{ position: 'fixed', top: 0, left: 0, zIndex: 99 }}>
            <button className='btn btn-dark shadow text-bold text-white frontal-top-left'
                onClick={props.cerrar}
                style={{ maxWidth: '200px' }} >
                Cerrar editor
            </button>
            <div className='row justify-content-center'>
                <div className='col-lg-8 bg-white round-m shadow mt-3 p-3'>
                    <div className='row justify-content-center ' id="hijo">
                        <div className='col-lg-12 mb-1 mt-2 h3 text-500'>Edición de entrada de plan de siembra</div>
                        <div className='col-lg-12 mb-4 mt-2 text-s text-300'>Modifique o elimine entradas al plan de siembra, es importante que el registro que esté editando sea de una semana posterior a la actual, verifique que así sea o el sistema le dirá que no es posible realizar cambios</div>
                        <FormularioRegistroBloqueEdicion setselecciones={setelement} selecciones={element} flores={flores} />

                        <div className='col-lg-12 mb-4'></div>
                        <button className='btn btn-dark shadow round-xl scale-05 ms-2 me-2 mt-2' style={{ backgroundColor: '#C20000', width: '160px' }} disabled={!canedit(props.elemento)} onClick={() => { accion(3) }} >Eliminar registro</button>
                        <button className='btn btn-dark shadow round-xl scale-05 ms-2 me-2 mt-2 text-bold' style={{ backgroundColor: '#7C0062', width: '300px' }}
                            disabled={!validarSemana(element.semanainicio)[0] || !validarSemana(element.transplante)[0] || !validarSemana(element.semanaCosecha)[0]}
                            onClick={() => { accion(1) }}>Actualizar este registro</button>

                    </div>
                </div>
            </div>
        </div>
    )
}

export default AgregarEntradaPlan;